import React from 'react';
import * as S from './TaProgressBar.styles';

const TaReview = ({progressBarData}) => {
  const getBarWidth = rating => {
    let barWidth = (100 / 58) * rating;
    return barWidth;
  };
  return (
    <S.TaProgressBarWrapDiv>
      <S.TaProgressBarInnerDiv>
        {progressBarData.map(data => (
          <S.TaProgressBarContentDiv>
            <S.TaTextDiv>{data.name}</S.TaTextDiv>
            <S.BarWrapDiv>
              <S.BarWrapInnerDiv>
                <S.InnerRatingBarWrapDiv width={getBarWidth(data.rating)}></S.InnerRatingBarWrapDiv>
              </S.BarWrapInnerDiv>
            </S.BarWrapDiv>
            <S.RatingNumberDiv>{data.count}</S.RatingNumberDiv>
          </S.TaProgressBarContentDiv>
        ))}
      </S.TaProgressBarInnerDiv>
    </S.TaProgressBarWrapDiv>
  );
};

export default TaReview;
